import React from 'react'

export default function FileIcon() {
  return (
    <div className="file-type-icon default">
      <img className="file-icon" alt="" />
    </div>
  )
}
